import 'css-chunksrc/client/scenes/strategicAxisCreation/form/projectAdequacyInput/styles.scss';export default {
  "form": "_form_15du8_1",
  "group": "_group_15du8_20",
  "input": "_input_15du8_24",
  "numberBox": "_numberBox_15du8_36"
};